import { useState } from "react";
import Icon from "../icons/Icon";
import Modal from "../modals/Modal";
import { useToast } from "../../contexts/ToastContext";
import { revokeKioskFn } from "../../services/kioskCallables";

/**
 * RevokeKioskModal — soft-revoke confirm. The device is signed out on its next
 * call (per-call recheck); past time records are kept for audit.
 */
const RevokeKioskModal = ({ kiosk, onClose, onRevoked }) => {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  const revoke = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await revokeKioskFn({ kioskId: kiosk.id });
      toast.success(`"${kiosk.name}" revoked.`);
      onRevoked?.();
    } catch (err) {
      toast.error(err?.message || "Failed to revoke kiosk.");
      setBusy(false);
    }
  };

  return (
    <Modal isOpen onClose={onClose} busy={busy} labelledBy="kiosk-revoke-title" className="kiosk-modal">
        <div className="kiosk-modal-header">
          <h2 id="kiosk-revoke-title" className="kiosk-modal-title">Revoke this kiosk?</h2>
          <div className="kiosk-modal-sub">
            The device will be signed out and can't punch until re-paired.
          </div>
        </div>
        <div className="kiosk-modal-body">
          <div className="kiosk-note danger">
            <Icon name="alert-triangle" />
            <div>
              Time records already recorded by <strong>{kiosk.name}</strong> are kept for audit — only the device's access is revoked.
            </div>
          </div>
        </div>
        <div className="kiosk-modal-footer">
          <button type="button" className="settings-btn settings-btn-secondary" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="settings-btn settings-btn-danger" onClick={revoke} disabled={busy}>
            {busy ? "Revoking…" : "Revoke kiosk"}
          </button>
        </div>
    </Modal>
  );
};

export default RevokeKioskModal;
